import { GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR } from '../constants'

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR) {
      return{
        ...state,
        patenteReject: null,
        sale: {
          ...state.sale,
          Taking_cars: [
          {
            ...action.data.takingCar,
            error: null,
          }
        ].concat(state.sale.Taking_cars),
        },
        isModified: action.data.isModified
      }
  }
  else {
      return state  
  }      
}